import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalReason } from '@/types/vehicle-withdrawal-reason'
import { AxiosResponse } from 'axios'

export function getVehicleWithdrawalReasons(): Promise<
  AxiosResponse<VehicleWithdrawalReason[]>
> {
  return instance.get(`/vehicle-withdrawal-reason`)
}
